module.exports = __webpack_public_path__ + "img/arrow-down-gray.7f8b7abe.svg";